import React from 'react';

function GalleryItem({image,clickTo}) {
  return (
    <dl className="gallery-item">
      <dt className="gallery-icon" onClick={clickTo}>
        <a href="#"  data-elementor-open-lightbox="yes" title={image.title??'a'}>
          <img
            decoding="async"
            src={image.image_link}
            className="attachment-thumbnail size-thumbnail image-section-photo"
            alt={image.title??'a'}
          />
          {image.post_link!=null && <div className='is_a_post'> View Post</div> }
        
        </a>
      </dt>
    </dl>
  );
}

export default GalleryItem;
